import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { PushPayExcludedLines } from "./pushpay-excluded-lines";
import { useStAdjustmentsSection } from "./st-adjustments-section";

export const StAdjustmentsHeader = () => {
  const { totals, warnings, selection } = useStAdjustmentsSection();

  if (!totals) return null;

  return (
    <Stack
      direction="row"
      align="center"
      justify="between"
      gap={4}
      className="w-full shrink-0 flex-wrap gap-y-3 border-b border-line px-4 py-3"
    >
      <Stack align="start" gap={1} className="min-w-0">
        <Text variant="label">
          {totals.pending === totals.count
            ? `${totals.pending} lines to push`
            : `${totals.pending} of ${totals.count} lines to push`}
        </Text>
        <Text variant="caption" tone="muted">
          {selection.hasSelection
            ? `${selection.selectedGroups.length} of ${selection.pushableGroups.length} technicians selected`
            : `${selection.pushableGroups.length} technicians with lines pending`}
        </Text>
      </Stack>
      <Stack gap={1} align="end" className="min-w-0 text-right">
        <Text variant="caption" tone="muted">
          Amounts reflect the current Grid status. Manually added lines will not
          be included in push.
        </Text>
        <PushPayExcludedLines warnings={warnings} />
      </Stack>
    </Stack>
  );
};
